import axios from 'axios'
import router from '../router/index'
import { alert, custom } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/ratingService";
const store = {};

function SortArray(x, y) {
    if (!x.Owner) { x.Owner="" }
    if (!y.Owner) { y.Owner="" }
    if (x.Owner.toLowerCase() < y.Owner.toLowerCase()) { return -1; }
    if (x.Owner.toLowerCase() > y.Owner.toLowerCase()) { return 1; }
    return 0;
}

const mutations = {
    GET_VOTING(state, posts) {
        if (posts.success == true) {
            posts.ratings.forEach(m => {
                if (m.Vote == null) {
                    m.Vote = {
                        RatId: null,
                        RatNoVote: null,
                        RatScore: null,
                        RatComment: "",
                    };
                }
            });
            state.userRatingList = posts.ratings;
            posts.topic.Owner = posts.topic.UsrCompany > '' ? posts.topic.UsrCompany : posts.topic.UserFullName;
            state.userRatingTopicInfo = posts.topic;
            state.userRatingTopicExpert = posts.tex;
            state.userRatingGroupInfo = posts.rtg;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    GET_PUBLIC_VOTING(state, posts) {
        if (posts.success == true) {
            posts.ratings.forEach(m => {
                if (m.Vote == null) {
                    m.Vote = {
                        RatId: null,
                        RatNoVote: null,
                        RatScore: null,
                        RatComment: "",
                    };
                }
            });
            state.userPublicRatingList = posts.ratings;
            posts.topic.Owner = posts.topic.UsrCompany > '' ? posts.topic.UsrCompany : posts.topic.UserFullName;
            state.userPublicRatingTopicInfo = posts.topic;
            state.userPublicRatingTopicExpert = posts.tex;
            state.userPublicRatingGroupInfo = posts.rtg;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    GET_MY_VOTING_OVERVIEW(state, posts) {
        var n = 1;
        if (posts.success == true) {
            posts.topics.forEach(m => {
                m.Owner = m.UsrCompany > '' ? m.UsrCompany : m.UserFullName;

            });
            state.myVotingOverviewTopics = posts.topics;
            state.myVotingOverviewTopics = state.myVotingOverviewTopics.sort(SortArray);
            state.myVotingOverviewTopics.forEach(m => {
             
                m.grpNum = n++;
            });

            state.myVotingOverviewInfo = posts.rtg;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SET_RATING() { }
};
const state = {
    userRatingList: [],
    userRatingTopicInfo: {},
    userRatingTopicExpert: {},
    userRatingGroupInfo: {},
    userPublicRatingList: [],
    userPublicRatingTopicInfo: {},
    userPublicRatingTopicExpert: {},
    userPublicRatingGroupInfo: {},
    ratingTypeGroupListIsLoading : false,
    publicRatingTypeGroupListIsLoading : false,
    myVotingOverviewTopics: [],
    myVotingOverviewInfo: {},
};
const getters = {};
const actions = {
    getVoting({ commit }, args) {
        state.ratingTypeGroupListIsLoading = true;
        const params = {
            rtgId: args.rtgId,
            topicId: args.topicId,
            args: args.args
        };
        axios
            .get(baseUri + '/GetVoting', { params })
            .then(res => {

                if (res.data.success == true) {
                    commit('GET_VOTING', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getPublicVoting({ commit }, args) {
        state.publicRatingTypeGroupListIsLoading = true;
        const params = {
            rtgId: args.rtgId,
            topicId: args.topicId,
            args: args.args
        };
        axios
            .get(baseUri + '/GetPublicVoting', { params })
            .then(res => {

                if (res.data.success == true) {
                    commit('GET_PUBLIC_VOTING', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getMyVotingOverview({ commit }, args) {
        state.ratingTypeGroupListIsLoading = true;
        const params = {
            rtgId: args.rtgId,
            topicId: args.topicId
        };
        axios
            .get(baseUri + '/GetMyVotingOverview', { params })
            .then(res => {
                console.log(res);
                if (res.data.success == true) {
                    commit('GET_MY_VOTING_OVERVIEW', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    updateMyVoting({ commit }, args) {
        console.log(args);

        var formData = new FormData();
        formData.append("RtgId", args.rtgId);
        formData.append("RtyId", args.rtyId);
        formData.append("Comment", args.ratComment);
        formData.append("Id", args.topicId);
        formData.append("score", args.ratScore);
        formData.append("RatNoVote", args.ratNoVote);
        axios
            .post(baseUri + '/SetRating', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_RATING', res.data);
                }
                else if (res.headers['content-type'] == "text/html; charset=utf-8") {

                    custom({
                        title: "Your session has expired.",
                        message: "For security reasons you have been automatically logged out after 60 minutes of no activity.<br/> Please click on “Go to Login“ to log in again.",
                        buttons: [{
                            text: "Go to Login",
                            onClick: function () {
                                router.push({
                                    name: 'Login'
                                });
                            }
                        },

                        ]
                    }).show().done();
                }

                else {
                    alert("An error occured while updating your record: " + res.data.errorMessage);
                }
            });
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}